// extracted by mini-css-extract-plugin
export default {"navigation-footer-wrapper":"BXaDt"};